import React, { forwardRef } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

const Scrollbar = forwardRef(({ children, ...props }, ref) => {
  return (
    <Scrollbars
      {...props}
      ref={ref}
      universal
      renderTrackVertical={({ style, ...props }) => (
        <div
          {...props}
          style={{
            zIndex: 1,
            right: "2px",
            bottom: "2px",
            top: "2px",
            borderRadius: "3px",
            ...style
          }}
        />
      )}
    >
      {children}
    </Scrollbars>
  );
});

export default Scrollbar;
